<script lang="ts" setup>
import { ref } from 'vue';
import { TabGroup, TabList, Tab, TabPanels, TabPanel } from '@headlessui/vue'
import { $fetch } from '@@home/plugins/fetch';
import { useI18n } from 'vue-i18n';
import { useAsyncData } from '@@home/hooks/async-data';

const { t } = useI18n();

const defaultProjectBg = 'https://res.oafimg.cn/-/a8ee53c6c404982d/XuperCore.png';

const description = [
  {
    title: t('projects.index.title1'),
    content: 'donorSubject',
  },
  {
    title: t('projects.index.title2'),
    content: 'contributeSubject',
  },
  {
    title: t('projects.index.title4'),
    content: 'techFeatures',
  },
  {
    title: t('projects.index.title5'),
    content: 'projectSponsor',
  },
  {
    title: t('projects.index.title3'),
    content: 'projectValue',
    clip: 2,
  },
]

const serviceTabList = ref([
  {
    title: t('projects.index.serviceTabList.title1'),
    content: [
      {
        id: 1,
        title: t('projects.index.serviceTabList.content.title1'),
        comment: t('projects.index.serviceTabList.content.comment1'),
        image: 'https://res.oafimg.cn/-/e5b792d8af013e33/service-1.png',
      },
      {
        id: 2,
        title: t('projects.index.serviceTabList.content.title2'),
        comment: t('projects.index.serviceTabList.content.comment2'),
        image: 'https://res.oafimg.cn/-/9c6cc0c4abe50b19/service-2.png',
      },
      {
        id: 3,
        title: t('projects.index.serviceTabList.content.title3'),
        comment: t('projects.index.serviceTabList.content.comment3'),
        image: 'https://res.oafimg.cn/-/0e3fe1e7590b139e/service-3.png',
      },
      {
        id: 4,
        title: t('projects.index.serviceTabList.content.title4'),
        comment: t('projects.index.serviceTabList.content.comment4'),
        image: 'https://res.oafimg.cn/-/875db793f193d861/service-4.png',
      },
    ],
  },
  {
    title: t('projects.index.serviceTabList.title2'),
    content: [
      {
        id: 1,
        title: t('projects.index.serviceTabList.content.title5'),
        comment: t('projects.index.serviceTabList.content.comment5'),
        image: 'https://res.oafimg.cn/-/46ae4acd4be07fd5/service-18.png',
      },
      {
        id: 2,
        title: t('projects.index.serviceTabList.content.title6'),
        comment: t('projects.index.serviceTabList.content.comment6'),
        image: 'https://res.oafimg.cn/-/7f58e65e08736e20/service-19.png',
      },
      {
        id: 3,
        title: t('projects.index.serviceTabList.content.title7'),
        comment: t('projects.index.serviceTabList.content.comment7'),
        image: 'https://res.oafimg.cn/-/b56d0cae264816fb/service-20.png',
      },
      {
        id: 4,
        title: t('projects.index.serviceTabList.content.title8'),
        comment: t('projects.index.serviceTabList.content.comment8'),
        image: 'https://res.oafimg.cn/-/592c03f46dfd5cf8/service-21.png',
      },
    ],
  },
  {
    title: t('projects.index.serviceTabList.title3'),
    content: [
      {
        id: 1,
        title: t('projects.index.serviceTabList.content.title9'),
        comment: t('projects.index.serviceTabList.content.comment9'),
        image: 'https://res.oafimg.cn/-/610e4710a6f59603/service-5.png',
      },
      {
        id: 2,
        title: t('projects.index.serviceTabList.content.title10'),
        comment: t('projects.index.serviceTabList.content.comment10'),
        image: 'https://res.oafimg.cn/-/e8cf47f0a63aec58/service-6.png',
      },
      {
        id: 3,
        title: t('projects.index.serviceTabList.content.title11'),
        comment: t('projects.index.serviceTabList.content.comment11'),
        image: 'https://res.oafimg.cn/-/d55bb18117a4fdc4/service-15.png',
      },
      {
        id: 4,
        title: t('projects.index.serviceTabList.content.title12'),
        comment: t('projects.index.serviceTabList.content.comment12'),
        image: 'https://res.oafimg.cn/-/1202916227537f5d/service-17.png',
      },
    ],
  },
  {
    title: t('projects.index.serviceTabList.title4'),
    content: [
      {
        id: 1,
        title: t('projects.index.serviceTabList.content.title17'),
        comment: t('projects.index.serviceTabList.content.comment17'),
        image: 'https://res.oafimg.cn/-/e3c81da433acab91/service-12.png',
      },
      {
        id: 2,
        title: t('projects.index.serviceTabList.content.title18'),
        comment: t('projects.index.serviceTabList.content.comment18'),
        image: 'https://res.oafimg.cn/-/45227d7be3ee18d0/service-13.png',
      },
      {
        id: 3,
        title: t('projects.index.serviceTabList.content.title19'),
        comment: t('projects.index.serviceTabList.content.comment19'),
        image: 'https://res.oafimg.cn/-/488c461ebd6f6ec4/service-14.png',
      },
      {
        id: 4,
        title: t('projects.index.serviceTabList.content.title20'),
        comment: t('projects.index.serviceTabList.content.comment21'),
        image: 'https://res.oafimg.cn/-/0fba5d43cb656106/service-7.png',
      },
      {
        id: 5,
        title: t('projects.index.serviceTabList.content.title21'),
        comment: t('projects.index.serviceTabList.content.comment20'),
        image: 'https://res.oafimg.cn/-/39509fefc982546e/service-16.png',
      },

    ],
  },
  {
    title: t('projects.index.serviceTabList.title5'),
    content: [
      {
        id: 1,
        title: t('projects.index.serviceTabList.content.title22'),
        comment: t('projects.index.serviceTabList.content.comment22'),
        image: 'https://res.oafimg.cn/-/13f7c234ebc5fd78/project-1.png',
      },
      {
        id: 2,
        title: t('projects.index.serviceTabList.content.title23'),
        comment: t('projects.index.serviceTabList.content.comment23'),
        image: 'https://res.oafimg.cn/-/a7767123ecd6bab1/project-2.png',
      },
      {
        id: 3,
        title: t('projects.index.serviceTabList.content.title24'),
        comment: t('projects.index.serviceTabList.content.comment24'),
        image: 'https://res.oafimg.cn/-/46ecec4f2c925218/project-3.png',
      },
      {
        id: 4,
        title: t('projects.index.serviceTabList.content.title25'),
        comment: t('projects.index.serviceTabList.content.comment25'),
        image: 'https://res.oafimg.cn/-/8d6878bb13f4b954/project-4.png',
      },
      {
        id: 5,
        title: t('projects.index.serviceTabList.content.title26'),
        comment: t('projects.index.serviceTabList.content.comment26'),
        image: 'https://res.oafimg.cn/-/e84c69f87dd953db/project-5.png',
      },
      {
        id: 6,
        title: t('projects.index.serviceTabList.content.title27'),
        comment: t('projects.index.serviceTabList.content.comment27'),
        image: 'https://res.oafimg.cn/-/b019a18087deec1c/project-6.png',
      },
    ],
  },
]);

const { data: incubateList } = useAsyncData('project:incubate', () => $fetch('/project/v1/list', { data: { status: 2 } }))
const { data: donateList } = useAsyncData('project:donate', () => $fetch('/project/v1/list', { data: { status: 1 } }))

const lookMore = ref(false);

const showMore = () => {
  lookMore.value = true;
}

const getTruncateClass = (item: any) => {
  if (item.projectCode && item.externalLink) {
    return 'max-w-70%';
  }
  if (item.projectCode || item.externalLink) {
    return 'max-w-80%';
  }
  return 'max-w-100%';
}
</script>

<template>
  <main class="page-projects">
    <div class="list-banner">
      <div class="banner-content container">
        <h1 class="m-0">{{ $t('projects.index.project1') }}</h1>
        <span class="block max-w-900px leading-30px <2xl:max-w-600px">{{ $t('projects.index.briefIntroduction1') }}</span>
      </div>
    </div>

    <div class="incubation-projects container">
      <h2 class="m-0">{{ $t('projects.index.project2') }}</h2>
      <p class="m-0">{{ $t('projects.index.briefIntroduction4') }}</p>
      <div class="incubation-list">
        <div class="incubation-card" v-for="(item) in incubateList" :key="item.id">
          <template v-if="item.id">
            <img :data-src="item.cardSidebar || defaultProjectBg" class="lazyload h-88px w-100% object-cover">
            <div class="p-32px pt-16px">
              <div class="content-titles">
                <span class="content-title truncate <2xl:max-w-60%" :class="getTruncateClass(item)" :title="item.title">{{ item.title }}</span>
                <a :href="item.projectCode" v-if="item.projectCode" target="_blank" class="content-jump">{{ $t('projects.index.codeCabin2') }}</a>
                <a :href="item.externalLink" v-if="item.externalLink" target="_blank" class="content-jump">{{ $t('projects.index.website2') }}</a>
              </div>
              <div class="h-128px overflow-y-auto">
                <div class="content-description" v-show="item[piece.content]" v-for="piece in description" :key="piece.title" :title="item[piece.content]">
                  <span class="description-title">{{ piece.title }}:</span>
                  <span class="truncate">{{ item[piece.content] }}</span>
                </div>
              </div>
              <RouterLink :to="`/project/${item.id}`" class="go-detail px-20px py-7px no-underline">{{ $t('projects.index.details2') }}</RouterLink>
            </div>
          </template>
        </div>
      </div>
    </div>

    <div class="donation-projects container">
      <h2 class="m-0">{{ $t('projects.index.project3') }}</h2>
      <p class="m-0">{{ $t('projects.index.briefIntroduction3') }}</p>
      <div class="donation-list">
        <div class="donation-card" v-for="(item) in lookMore ? donateList : donateList?.slice(0, 9)" :key="item.id">
          <template v-if="item.id">
            <div class="content-titles">
              <img class="lazyload content-icon" v-if="item.cardLogo" :data-src="item.cardLogo">
              <span class="content-title truncate <2xl:max-w-60%" :class="getTruncateClass(item)" :title="item.title" v-else>{{ item.title }}</span>
              <a :href="item.projectCode" v-if="item.projectCode" target="_blank" class="content-jump">{{ $t('projects.index.codeCabin2') }}</a>
              <a :href="item.externalLink" v-if="item.externalLink" target="_blank" class="content-jump">{{ $t('projects.index.website2') }}</a>
            </div>
            <div class="h-160px overflow-y-auto">
              <div class="content-description" v-show="item[piece.content]" v-for="piece in description" :key="piece.title" :title="item[piece.content]">
                <span class="description-title">{{ piece.title }}:</span>
                <span class="truncate">{{ item[piece.content] }}</span>
              </div>
            </div>
            <RouterLink :to="`/project/${item.id}`" class="go-detail px-20px py-7px no-underline">{{ $t('projects.index.details2') }}</RouterLink>
          </template>
        </div>
      </div>
      <div class="more" v-if="!lookMore">
        <span class="more-cursor" @click="showMore()">
          <span>{{ $t('projects.index.moreProjects') }}</span>
          <span class="i-home-icons:arrow-down"></span>
        </span>
      </div>
    </div>

    <div class="openatom-service">
      <h2 class="m-0">{{ $t('projects.index.foundationService') }}</h2>
      <div class="container">
        <TabGroup v-slot="{ selectedIndex }">
          <TabList class="flex justify-center">
            <Tab v-for="item in serviceTabList" :key="item.title" as="template" v-slot="{ selected }">
              <div :class="{ selected }" class="tablist-btn w-146px flex items-center justify-center break-words pb-16px siblings:ml-88px">
                {{ item.title }}
              </div>
            </Tab>
          </TabList>

          <div class="h-1px w-full overflow-hidden bg-[rgba(45,45,45,.06)]">
            <!-- (container宽度 - (tab宽度 * tab数量 + tab间距 * (tab数量 - 1))) / 2 = ml值 -->
            <!-- (1360 - (146 * 5 + 88 * (5 - 1))) / 2 = 139 -->
            <!-- (1200 - (146 * 5 + 88 * (5 - 1))) / 2 = 59 -->
            <div
              class="ml-139px h-full w-fit flex flex-nowrap transition-transform duration-300 <2xl:ml-59px after:w-88px after:content-empty"
              :style="{ transform: `translateX(${selectedIndex * 100}%)` }"
            >
              <div class="w-146px bg-brand-primary"></div>
            </div>
          </div>

          <TabPanels class="relative">
            <TabPanel v-for="item in serviceTabList" :key="item.title" as="template" static v-slot="{ selected }">
              <Transition name="tab-panel">
                <ul class="m-0 flex flex-wrap list-none justify-start p-0" v-show="selected">
                  <li class="tab-card mr-[32px] <2xl:mr-24px" v-for="piece in item.content" :key="piece.id">
                    <img :data-src="piece.image" class="lazyload card-img block" :alt="piece.title">
                    <div class="card-description">
                      <div class="card-description-inner overflow-y-auto">
                        <h4 class="m-0 px-32px">{{ piece.title }}</h4>
                        <p class="mb-0 mt-8px px-32px text-center">{{ piece.comment }}</p>
                      </div>
                    </div>
                  </li>
                </ul>
              </Transition>
            </TabPanel>
          </TabPanels>
        </TabGroup>
      </div>
    </div>
  </main>
</template>

<style lang="scss" scoped>
.page-projects {
  font-weight: 400;
  background-color: #fff;

  .list-banner {
    height: 400px;
    color: #2d2d2d;
    background: url(@current/assets/project/banner.jpg) no-repeat;
    background-position: right;
    background-size: cover;

    .banner-content {
      padding-top: 143px;

      h1 {
        margin-bottom: 18px;
        font-weight: 500;
        font-size: 50px;
      }

      span {
        font-size: 24px;
      }
    }
  }

  .incubation-projects {
    padding: 48px 0;
    background-color: #fff;

    h2 {
      margin-bottom: 8px;
      color: #2d2d2d;
      font-weight: 500;
      font-size: 32px;
      line-height: 48px;
      text-align: center;
    }

    p {
      margin-bottom: 32px;
      color: #2d2d2d;
      font-weight: 400;
      font-size: 16px;
      line-height: 24px;
      text-align: center;
    }

    .incubation-list {
      display: flex;
      flex-wrap: wrap;
      justify-content: flex-start;
    }

    .incubation-card {
      border: 1px solid rgba(154, 158, 166, 0.1);
      box-shadow: 0 0 16px 0 rgba(0, 0, 0, 0.04);
      transition: all linear .2s;

      @apply box-border w-432px h-356px mb-32px bg-[#fff] rounded-4px ml-32px <2xl:w-384px <2xl:ml-24px;

      &:nth-child(3n+1) {
        margin-left: 0;
      }

      .content-titles {
        display: flex;
        align-items: center;
        height: 36px;
        color: #2d2d2d;
        font-size: 24px;
      }

      .content-icon {
        width: 130px;
        height: 36px;
        object-fit: cover;
      }

      .content-title {
        display: inline-block;
        height: 36px;
        margin-bottom: 4px;
        color: #2d2d2d;
        font-weight: 500;
        font-size: 24px;
        line-height: 36px;
      }

      .content-jump {
        display: inline-block;
        height: 24px;
        margin-left: 16px;
        color: #1180ff;
        font-weight: 400;
        font-size: 14px;
        line-height: 24px;
        text-decoration: underline;
        cursor: pointer;
      }

      .content-description {
        display: flex;
        margin-top: 8px;
        color: #2d2d2d;
        font-weight: 400;
        font-size: 16px;
        line-height: 24px;
      }

      .description-title {
        flex-shrink: 0;
        margin-right: 8px;
      }

      .go-detail {
        display: inline-block;
        margin-top: 24px;
        color: #1180ff;
        font-weight: 400;
        font-size: 14px;
        text-align: center;
        border: 1px solid #1180ff;
        border-radius: 4px;
        cursor: pointer;
      }

      &:hover {
        transform: translateY(-12px);

        .go-detail {
          color: #fff;
          background: #1180ff;
          border: unset;
        }
      }
    }
  }

  .donation-projects {
    padding: 48px 0;
    background-color: #fff;

    h2 {
      margin-bottom: 8px;
      color: #2d2d2d;
      font-weight: 500;
      font-size: 32px;
      line-height: 48px;
      text-align: center;
    }

    p {
      margin-bottom: 32px;
      color: #2d2d2d;
      font-weight: 400;
      font-size: 16px;
      line-height: 24px;
      text-align: center;
    }

    .donation-list {
      display: flex;
      flex-wrap: wrap;
      justify-content: flex-start;
    }

    .donation-card {
      background: rgba(45, 45, 45, 0.02);
      border: 1px solid rgba(154, 158, 166, 0.2);
      @apply box-border w-432px h-320px mb-32px p-32px rounded-4px ml-32px <2xl:w-384px <2xl:h-304px <2xl:ml-24px <2xl:p-24px;

      &:nth-child(3n+1) {
        margin-left: 0;
      }

      .content-titles {
        display: flex;
        align-items: center;
        height: 36px;
        color: #2d2d2d;
        font-size: 24px;
      }

      .content-icon {
        width: 130px;
        height: 36px;
        object-fit: cover;
      }

      .content-title {
        display: inline-block;
        height: 36px;
        margin-bottom: 4px;
        color: #2d2d2d;
        font-weight: 500;
        font-size: 24px;
        line-height: 36px;
      }

      .content-jump {
        display: inline-block;
        height: 24px;
        margin-left: 16px;
        color: #1180ff;
        font-weight: 400;
        font-size: 14px;
        line-height: 24px;
        text-decoration: underline;
        cursor: pointer;
      }

      .content-description {
        display: flex;
        margin-top: 16px;
        color: #2d2d2d;
        font-weight: 400;
        font-size: 16px;
        line-height: 24px;
      }

      .description-title {
        flex-shrink: 0;
        margin-right: 8px;
      }

      .go-detail {
        display: inline-block;
        margin-top: 28px;
        color: #1180ff;
        font-weight: 400;
        font-size: 14px;
        text-align: center;
        border: 1px solid #1180ff;
        border-radius: 4px;
        cursor: pointer;
      }

      &:hover {
        background: #fff;
        box-shadow: 0 0 16px 0 rgba(0, 0, 0, 0.04);

        .go-detail {
          color: #fff;
          background: #1180ff;
          border: unset;
        }

        .content-title {
          color: #1180ff;
        }
      }
    }

    .more {
      display: flex;
      align-items: center;
      justify-content: center;
      height: 22px;
      margin: 0 auto 12px;
      color: #1180ff;
      font-weight: 400;
      font-size: 16px;

      &-cursor {
        display: flex;
        align-items: center;
        cursor: pointer;
      }

      img {
        margin-left: 4px;
      }
    }
  }

  .openatom-service {
    padding: 36px 0 96px;
    background: rgba(45, 45, 45, 0.02);

    > h2 {
      height: 48px;
      margin-bottom: 48px;
      color: #2d2d2d;
      font-weight: 500;
      font-size: 32px;
      line-height: 48px;
      text-align: center;
    }

    .tablist-btn {
      color: #2d2d2d;
      font-weight: 400;
      font-size: 24px;
      text-align: center;
      cursor: pointer;

      &:focus-visible {
        outline: unset;
      }

      &.selected {
        color: #1180ff;
      }
    }

    .tab-panel-enter-active,
    .tab-panel-leave-active {
      transition: transform .9s, opacity .9s;
      will-change: transform, opacity;
    }

    .tab-panel-leave-active {
      position: absolute;
      top: 0;
      left: 0;
    }

    .tab-panel-enter-from,
    .tab-panel-leave-to {
      transform: translateY(12px);
      opacity: 0;
    }

    .tab-card {
      flex-shrink: 0;
      box-shadow: rgba(0, 0, 0, 0.08) 0 0 8px 0;
      @apply w-316px h-286px relative  mt-32px  overflow-hidden bg-[#fff] rounded-4px <2xl:w-282px <2xl:h-256px;

      &:nth-child(4n) {
        margin-right: 0;
      }

      &:hover {
        .card-description {
          padding-top: 24px;
          padding-bottom: 24px;
          transform: translateY(-74px);

          .card-description-inner {
            height: calc(100% - 48px);
          }
        }

        h4 {
          height: auto;
        }
      }
    }

    .card-img {
      @apply w-100% h-214px object-cover <2xl:h-184px;
    }

    .card-description {
      position: absolute;
      z-index: 1;
      width: 100%;
      height: 146px;
      background-color: #fff;
      transition: transform 0.3s;

      h4 {
        display: flex;
        align-items: center;
        justify-content: center;
        height: 74px;
        color: #2d2d2d;
        font-weight: 500;
        font-size: 16px;
        line-height: 24px;
        text-align: center;
      }

      p {
        color: #9a9ea6;
        font-weight: 400;
        font-size: 14px;
        line-height: 22px;
      }
    }
  }
}
</style>
